import styled from 'styled-components';
import { Link } from 'gatsby';
import { motion } from 'framer-motion';

export const AsideWrapper = styled(motion.div)`
  display: none;
  @media (min-width: 768px) {
    display: block;
    position: fixed;
    right: 0;
    z-index: 91;
    top: 50%;
    transform: translate(0, -50%);
  }
`;

export const WidgetPart = styled.div`
  position: relative;
`;

export const TabIcon = styled.div`
  background: ${({ selected }) => (selected ? '#1b7bdd' : 'rgba(0, 0, 0, 0.5)')};
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  margin: 0 0 1px 1px;
  transition: 0.3s;
  padding: 10px;
  align-items: center;
  border: none;

  &:hover {
    background-color: #1b7bdd;
  }

  &.active {
    background: #1b7bdd;
    margin: 0 0 1px;
  }

  .icon-search {
    background: url(/svg/sprites.svg#searchw) no-repeat;
    width: 40px;
    height: 40px;
  }

  .icon-location {
    background: url(/svg/sprites.svg#wlocate) no-repeat;
    width: 30px;
    height: 40px;
  }

  .icon-contact {
    background: url(/svg/sprites.svg#wcontact) no-repeat;
    width: 30px;
    height: 40px;
  }
`;

export const TabPanelBlock = styled(motion.div)`
  width: 340px;
  position: absolute;
  right: calc(100% - 1px);
  top: 0;
  transform: translate(0%, 0);
  transition: all 0.3s;
`;

export const TabPanel = styled.div`
  padding: 20px 30px 30px;
  background: #1b7bdd;
  color: #fff;
  width: 100%;

  h5 {
    font-size: 16px;
    font-family: ${({ dir }) =>
      dir === 'rtl' ? 'GESSTwoDWTCMedium,serif!important' : 'LibreBaskervilleRegular'};
    font-weight: 400;
    line-height: 30px;
    margin: 0 0 1rem;
  }
`;

export const EventUL = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

export const ListTab = styled.li`
  display: flex;
  justify-content: space-between;
  padding: 1rem 0;

  p {
    margin: 0;
    text-transform: uppercase;
    font-size: ${({ dir }) => (dir === 'rtl' ? '13px!important' : '10px!important')};
    letter-spacing: 2.18px;
    margin: ${({ dir }) => (dir === 'rtl' ? '0px' : '')};
    line-height: ${({ dir }) => (dir === 'rtl' ? '20px!important' : '')};
  }

  .ev-date {
    width: 23%;
    display: flex;
    flex-flow: column;
    justify-content: center;
    border-right: ${({ dir }) => (dir === 'rtl' ? '' : '1px solid #579de5')};
    border-left: ${({ dir }) => (dir === 'rtl' ? '1px solid #579de5' : '')};
    text-align: center;
    text-transform: uppercase;
    font-size: 8px;
    color: #fff;

    svg {
      width: 25px;
      height: 25px;
      margin: 0 auto 0.5rem;
    }
  }

  &.transport {
    border-bottom: 1px solid #579de5;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    .t-icon {
      margin: 0 1rem 1rem;
    }

    .icon-1 {
      svg {
        width: 32px;
        height: 49px;
      }
    }

    .icon-2 {
      svg {
        width: 51px;
        height: 48px;
      }
    }

    p {
      width: 100%;
      color: #fff;
      text-align: center;
    }
  }

  &.drvparking {
    display: flex;
    justify-content: center;
    padding: 1rem 0;
    border-bottom: 1px solid #579de5;

    p {
      padding: 0.5rem 0.75rem;
      color: #fff;
    }

    .dp-icon {
    }
  }

  &.taxiservice {
    display: flex;
    justify-content: center;
    padding: 1rem 0 0;

    .ts-icon {
      margin: 0 1rem;
    }

    .icon-1 {
      svg {
        width: 76px;
        height: 17px;
      }
    }

    .icon-2 {
      svg {
        width: 63px;
        height: 14px;
      }
    }
  }

  svg {
    width: 50px;
    height: 39px;
    path,
    polygon {
      fill: #fff;
    }
  }
`;

export const EventInfo = styled.div`
  width: 70%;

  .ev-tag {
    text-transform: uppercase;
    display: block;
    font-weight: 700;
    font-size: 10px;
    letter-spacing: 2.18px;
    color: #fff;
  }

  .ev-title {
    font-size: 14px;
    font-family: 'LibreBaskervilleRegular', serif;
    display: block;
    margin: 1rem 0;
    letter-spacing: normal;
    text-transform: none;
  }
  p {
    line-height: ${({ dir }) => (dir === 'rtl' ? '20px' : '')};
  }
`;

export const EventLink = styled(Link)`
  font-size: ${({ dir }) => (dir === 'rtl' ? '15px' : '14px')};
  font-family: ${({ dir }) =>
    dir === 'rtl' ? 'GESSTwoDWTCLight,sans-serif' : 'LibreBaskervilleRegular, serif'};
  display: block;
  margin: 1rem 0;
  letter-spacing: normal;
  text-transform: none;
  color: #fff;
`;

export const CtaButton = styled.div`
  padding: 10px 0 0;
  text-align: center;
  a {
    color: #fff;
  }
`;

export const GettingHereLink = styled(Link)`
  color: #fff;
`;

export const ContactUl = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

export const Contactli = styled.li`
  border-bottom: 1px solid #579de5;
  padding: 1rem 0;
  &:last-child {
    border-bottom: 0px;
  }
  p {
    margin: ${({ dir }) => (dir === 'rtl' ? '0px' : '')};
    line-height: ${({ dir }) => (dir === 'rtl' ? '20px!important' : '')};
  }
`;

export const ContactLink = styled(Link)`
  display: flex;

  p {
    color: #fff;
    display: flex;
    flex-flow: column;
    justify-content: center;
    margin: 0 1rem 0;
    text-transform: uppercase;
    font-size: ${({ dir }) => (dir === 'rtl' ? '13px!important' : '10px!important')};
    letter-spacing: 2.18px;
    font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCLight,sans-serif!important' : '')};
  }
  .call_us {
    direction: ${({ dir }) => (dir === 'rtl' ? 'ltr' : 'rtl')};
  }
`;

export const ContactIcon = styled.div`
  width: 40px;

  &.smarticon {
    svg {
      width: 25px;
      height: 44px;
      fill: #fff;
    }
  }

  &.message {
    svg {
      width: 23px;
      height: 30px;
      fill: #fff;
    }
  }

  &.enquiryicon {
    svg {
      width: 32px;
      height: 39px;
      fill: #fff;
    }
  }
`;
